import _extends from "@babel/runtime/helpers/extends";
import { Button } from '@material-ui/core';
import React from 'react';
export const SaveButton = _ref => {
  let {
    localization,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Button, _extends({
    "aria-label": localization.label,
    color: "primary",
    variant: "contained",
    autoFocus: true,
    disabled: props.disabled || false
  }, props), localization.label);
};
//# sourceMappingURL=save-button.js.map